import type { ReactNode } from 'react'
import React from 'react'

import { FooterContainer } from 'Footer'
import { Header } from 'Header'

type FullPageProps = {
  children: ReactNode
  route: {
    props: {
      footerType?: string
      footerIsOnLandingPage: boolean
      showHeaderWithoutNavLink?: boolean
      hasLoginModal?: boolean
    }
  }
}
export const FullPage = ({
  children,
  route: {
    props: {
      footerIsOnLandingPage,
      footerType,
      showHeaderWithoutNavLink = false,
      hasLoginModal = false,
    },
  },
}: FullPageProps) => (
  <>
    <Header simple={showHeaderWithoutNavLink} hasLoginModal={hasLoginModal} />
    {children}
    <FooterContainer type={footerType} copyright isOnLandingPage={footerIsOnLandingPage} />
  </>
)
